import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, timeout: 90000 });

export const photoUrl = (mealId) => `${API}/meals/${mealId}/photo`;
export const photoUrlAt = (mealId, i) => `${API}/meals/${mealId}/photo/${i}`;

export const api = {
  // Meals/drinks/packages
  analyze: async ({ files, file, note, date, kind = "meal" }) => {
    const list = files && files.length ? files : file ? [file] : [];
    const fd = new FormData();
    list.forEach((f) => fd.append("photos", f));
    fd.append("kind", kind);
    if (note) fd.append("note", note);
    if (date) fd.append("date", date);
    const { data } = await http.post("/meals/analyze", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  listMeals: async (kind) => (await http.get(`/meals${kind ? `?kind=${kind}` : ""}`)).data,
  logAgain: async (id) => (await http.post(`/meals/${id}/log-again`)).data,
  deleteMeal: async (id) => (await http.delete(`/meals/${id}`)).data,

  // Habits
  todayHabit: async () => (await http.get("/habits/today")).data,
  upsertHabit: async (payload) => (await http.post("/habits", payload)).data,
  listHabits: async (days = 30) => (await http.get(`/habits?days=${days}`)).data,

  // Weight
  addWeight: async (payload) => (await http.post("/weight", payload)).data,
  listWeight: async (days = 365) => (await http.get(`/weight?days=${days}`)).data,

  // Dashboard
  dashboard: async () => (await http.get("/dashboard")).data,

  // Settings (daily calorie budget)
  getSettings: async () => (await http.get("/settings")).data,
  saveSettings: async (payload) => (await http.post("/settings", payload)).data,

  // Coach
  weeklyCoach: async () => (await http.post("/coach/weekly")).data,
  monthlyStats: async (days = 30) => (await http.get(`/monthly/stats?days=${days}`)).data,
  monthlyCoach: async (days = 30) => (await http.post(`/coach/monthly?days=${days}`)).data,

  // Export
  exportUrl: () => `${API}/export`,
};
